// Issue #82: 勤怠種別（Activity Type）の選択肢が Create 系 2 フォームと Edit フォームで
// 別々に定義され、ラベルが食い違っていた（Create「H: Official & Public Holidays」に対し
// Edit「H: Official holiday」等）。同じ種別が画面によって違う名前で見えると、利用者は
// 別の区分だと受け取る。定義をここへ集約し全フォームで同一の文言を使う。
//
// 業務上の意味は docs/domain/用語集.md が正。特に「J: Home assignment」は在宅勤務ではなく
// 日本国内での勤務（日本アサイン）を指す。ラベルを訳し直す際は用語集を先に引くこと。

/** 勤怠種別コード（バックエンドが返す文字列）→ フォームで扱う数値 */
export const ACTIVITY_TYPE_MAPPING = {
	H: 0,
	C: 1,
	X: 2,
	J: 3,
};

/** antd Select の options 形式。全フォームで共有する。 */
export const ACTIVITY_TYPE_OPTIONS = [
	{
		value: ACTIVITY_TYPE_MAPPING.H,
		label: "H: Official & Public Holidays",
	},
	{
		value: ACTIVITY_TYPE_MAPPING.C,
		label: "C: In Cairo",
	},
	{
		value: ACTIVITY_TYPE_MAPPING.X,
		label: "X: Day Off (Annual leave)",
	},
	{
		value: ACTIVITY_TYPE_MAPPING.J,
		label: "J: Home assignment",
	},
];

/**
 * antd Table の filters 形式（Issue #83）。
 *
 * 一覧の Activity Type 列はバックエンドが返すコード文字列（"H" 等）をそのまま
 * 表示するため、value はコード側に合わせる（options の value は数値で別物）。
 * ラベルは入力フォームと同じ文言を使い、画面ごとに呼び名が変わらないようにする。
 */
export const ACTIVITY_TYPE_FILTERS = Object.entries(ACTIVITY_TYPE_MAPPING).map(
	([code, value]) => ({
		text: ACTIVITY_TYPE_OPTIONS.find((option) => option.value === value).label,
		value: code,
	}),
);
